import React from "react";
import PropTypes from "prop-types";

import formatUSD from "utils/formatUSD";
import { Paragraph } from "components/core/Typography";
import { FacilityPageSection } from "components/facility/FacilityPageSection";

const AdminFeeSection = ({ adminFee }) => (
	<FacilityPageSection
		title="Admin Fee"
		isCollapsable
	>
		<Paragraph>{formatUSD(adminFee, { showDecimal: true })}</Paragraph>
		<Paragraph>
			This is a fee from the facility due when you move into a storage
			unit.
		</Paragraph>
	</FacilityPageSection>
);

AdminFeeSection.propTypes = {
	adminFee: PropTypes.number
};

export default AdminFeeSection;
